export default __webpack_public_path__ + "static/dairy-free-taste-2-desktop-ca19b325cd0759bb06fc60202a96a243.png";